import { createClient, SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Check if environment variables are configured
export const isSupabaseConfigured = !!(supabaseUrl && supabaseAnonKey)

// Only log in development
if (import.meta.env.DEV) {
  console.log('Supabase configured:', isSupabaseConfigured)
  if (isSupabaseConfigured) {
    console.log('Supabase URL:', supabaseUrl)
  }
}

// Create a safe supabase client that won't crash if env vars are missing
let supabaseInstance: SupabaseClient | null = null

if (isSupabaseConfigured) {
  supabaseInstance = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
    global: {
      headers: {
        'x-client-info': 'buildfast-shop'
      }
    },
    realtime: {
      timeout: 10000
    }
  })
}

// Export a proxy that shows helpful error if supabase is not configured
export const supabase = new Proxy({} as SupabaseClient, {
  get(_, prop) {
    if (!supabaseInstance) {
      if (import.meta.env.DEV) {
        console.error('Supabase is not configured. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY environment variables.')
      }
      // Return a no-op function for method calls to prevent crashes
      return () => Promise.resolve({ data: null, error: new Error('Supabase not configured') })
    }
    return (supabaseInstance as unknown as Record<string, unknown>)[prop as string]
  }
}) as SupabaseClient
